import * as Sentry from '@sentry/react';
import { merge } from 'lodash';
import { applyMiddleware, compose, createStore, Store } from 'redux';
import { Persistor, persistReducer, persistStore } from 'redux-persist';
import createFilter from 'redux-persist-transform-filter';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import en from './constants/translations/en-US.json';
import vi from './constants/translations/vi-VN.json';
import rootReducer from './reducers';

const sentryReduxEnhancer = Sentry.createReduxEnhancer();
const enhancers = [sentryReduxEnhancer];
const initialState = {
  user: {
    company: null,
    full_name: null,
    id: null,
    phone_number: null,
    settings: null,
    username: null,
    token: null,
    role_id: '',
    team: null,
    regions: [],
  },
};
const middleware = [thunk];
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    tracesSampleRate: 0.2,
    transport: Sentry.makeXHRTransport,
  });
}
const saveSubsetFilter = createFilter('user', [
  'id',
  'verified',
  'full_name',
  'company',
  'company_member',
  'is_staff',
  'can_gen_vcard',
  'can_gen_without_invoice',
  'role',
  'team',
  'group',
  'regions',
]);
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'constants', 'locale', 'zopim'],
  transforms: [saveSubsetFilter],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = (window as any).__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);
const configureStore = (): {
  store: Store<AppState>;
  persistor: Persistor;
} => {
  const rawStore = createStore(
    persistedReducer,
    initialState,
    composedEnhancers
  );
  const rawPersistor = persistStore(rawStore);
  return { store: rawStore, persistor: rawPersistor };
};

const { store, persistor } = configureStore();
const trans = {
  en,
  vi: merge({}, en, vi),
};

let state = store.getState();
store.subscribe(() => {
  state = store.getState();
});
export const translation = () => {
  const locale = state?.locale?.currentLocale || 'en';
  return trans[locale] || trans.en;
};

export default { store, persistor };
